import { mockAttendanceAchievements } from './attendanceMocks';

export const gamificationDefaults = {
    // Frequência - Aluno (Member)
    memberAttendancePresent: 1,
    memberAttendanceExcused: 1,
    memberAttendanceUnexcused: 0,

    // Frequência - Professor
    teacherAttendancePresent: 1,
    teacherAttendanceExcused: 1,
    teacherAttendanceUnexcused: 0,

    // Sistema de Avaliação (Passagem de Nível)
    minScoreToPassPercent: 70, // %
    requireFundamentalsMaxScore: true, // Obrigatório tópicos fundamentais terem nota máxima
    xpRewardMemberPass: 50, // XP para aluno ao passar
    xpRewardTeacherPass: 25, // XP para professor quando aluno passar

    // Outras formas de pontuação (Geral / Somatória / Streaks)
    rankingCalculationStrategy: 'sum_all', // 'sum_all', 'weighted', etc.
    attendanceStreakRequired: 0, // Dias seguidos para ganhar bônus (0 desativa)
    attendanceStreakBonusXp: 0, // Quantidade de XP extra

    // Conquistas & Insígnias (Achievements & Badges)
    achievements: mockAttendanceAchievements,

    // Níveis de Gamificação (Ranks) Fixos 1 ao 20
    levelRanks: Array.from({ length: 20 }).map((_, i) => ({
        id: `rank_${i + 1}`,
        name: `Nível ${i + 1}`,
        minXp: i === 0 ? 0 : i * 100, // Default linearly increasing points, level 1 starts at 0
        imageId: `rank_${i + 1}`
    }))
};
